<svelte:head>
  <title>Code of Conduct</title>
  <meta
    name="description"
    content="PGConf.dev is committed to a safe, inclusive, and harassment-free conference. Attendees should contact the Code of Conduct committee for help."
  />
</svelte:head>

<h1>Code of Conduct</h1>

<p>
  PGConf.dev is dedicated to providing a harassment-free conference experience
  for everyone. We do not tolerate harassment of conference participants in any
  form. Sexual language and imagery is not appropriate for any conference venue,
  including talks.
</p>

<p>
  Conference participants violating this policy may be sanctioned or expelled
  from the conference without a refund at the discretion of the Code Of Conduct
  committee.
</p>

<p>
  Harassment includes offensive verbal comments related to gender, sexual
  orientation, disability, physical appearance, race, religion, sexual images in
  public spaces, deliberate intimidation, stalking, following, harassing,
  photography or recording, sustained disruption of talks or other events,
  inappropriate physical contact, and unwelcome sexual attention. Participants
  asked to stop any harassing behavior are expected to comply immediately.
  Failure to comply will result in sanctions and/or ejection from the conference
  without a refund.
</p>

<p>
  If a participant engages in harassing behaviour, the conference organizers
  will work with the Code Of Conduct Committee to decide what action to take,
  including but not limited to: warning the offender, expulsion from the
  conference with no refund, and/or referral to appropriate authorities. If you
  are being harassed, notice that someone else is being harassed, or have any
  other concerns, please contact a member of the conference staff, including
  anyone on the conference committee, or the Code of Conduct committee,
  immediately.
</p>

<p>
  Conference staff will be happy to help participants contact venue security or
  local law enforcement, provide escorts, or otherwise assist those experiencing
  harassment to feel safe for the duration of the conference. We value your
  attendance. Decisions regarding appropriate assistance will be at the sole
  discretion of the conference committee.
</p>

<p>
  All participants are expected to adhere to this policy at all conference
  venues and conference-related social events.
</p>

<p>
  You can reach the code of conduct committee through email at <a
    href="mailto:coc2026@pgconf.dev">coc2026@pgconf.dev</a
  >
</p>
